import { UserRoles } from "../enums/userRoles.enum";

export const getRoleLabel = (role?: UserRoles): string => {
  switch (role) {
    case UserRoles.owner:
      return "Branch Owner"; // This is correct. branch is the indipendnet entity.
    case UserRoles.admin:
      return "Administrator";
    case UserRoles.employee:
    default:
      return "Employee";
  }
};
